import React from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";
import Header from "./Header";
import Footer from "./Footer";
import Line from "./Line";

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  return (
    <>
      <div className="footerbottom wavebackground">
        <Header siteTitle={data.site.siteMetadata.title} />
        <Line />
        <main>{children}</main>
        <Line />
        <Footer siteTitle={data.site.siteMetadata.title} />
      </div>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
